import { EDPFloorSpaceInfo } from './floor-container/floor/floor.model';
import { EDPElevatorBank, ElevatorBankProcessed } from './floor-container/elevator-banks/elevator-banks.model';
import { FloorClass } from '../models/floor.class';
import { SPDataStatus } from '../stacking-plan.model';

export enum StackViewType {
  Default = 0,
  PropertyView,
}

export interface StackingPlanContainer {
  totalNumberOfFloors: number;
  totalNumberOfFloorsUnderground: number;
  netRentableArea: number;
  netRentableAreaUOM: string;
  totalGrossArea?: number;
  totalGrossAreaUOM?: string;
  totalGrossOfficeArea?: number;
  totalGrossOfficeAreaUOM?: string;
  unknownIssues?: number;
  expiredIssues?: number;
  commonFloorSize: number;
  commonFloorSizeUOM: string;
  elevatorBank: EDPElevatorBank[];
  floors: EDPFloorSpaceInfo[];
  minimumFloorArea: number;
  minimumFloorAreaUOM?: string;
  maximumFloorArea: number;
  maximumFloorAreaUOM?: string;
  totalVacancyArea: number;
  totalVacancyAreaUOM: string;
  dataStatus?: SPDataStatus;
  is_selected_usage_primary?: boolean;
  has_usage_primary?: boolean;
}

export interface ElevatorBank {
  elevatorBankId?: number;
  elevatorTypeDesc: string;
  elevatorBankName: string;
  totalNumberOfFloors?: number;
  baseStop?: string;
  firstStop: string;
  lastStop: string;
  elevatorBankCapacity: number;
  elevatorBankCapacityUOM: string;
  adaCompliant: boolean;
  elevatorBankNotes: string;
}

export interface FloorsElevators {
  floorInfo: FloorClass[];
  elevatorInfo: ElevatorBank[];
  elevatorInfoProcessed: ElevatorBankProcessed[][];
}

export interface MediaInfo {
  edpMultimediaKey?: string;
  originalLocationURI?: string;
  thumbLocationURI?: string;
}
